import ApplicantRepository from "../../ports/applicantRepository";
import { ApplicantType } from "../../../entities/applicant";

export type addApplicantUsecase = (applicant: ApplicantType) => Promise<any>;

export const buildAddApplicant = (dependencies: {
  applicantRepo: ApplicantRepository;
}): addApplicantUsecase => {
  const { applicantRepo } = dependencies;

  const addApplicant: addApplicantUsecase = async (applicant: ApplicantType) =>
    applicantRepo.addApplicant(applicant);

  return addApplicant;
};
